import React from "react"
import Header from "./header"
import Image from "./image"
import Tracks from "./tracks"
import GrayLine from "./gray-line"

const Artist = ({ attributes, images, title, editing, tracks }) => {
  return (
    <>
      <table
        data-testid="artist"
        {...attributes}
        style={{ borderCollapse: "collapse", padding: "0", width: "357px" }}
      >
        <tbody>
          <tr>
            <Image images={images} editing={editing} />
            <td
              style={{
                backgroundColor: "black",
                background: "linear-gradient(gray, 30%, black)",
                width: "250px",
                paddingLeft: "12px",
                paddingRight: "12px"
              }}
            >
              <Header title={`Top tracks for ${title}`} />
              <GrayLine marginTop="35px" />
            </td>
          </tr>
        </tbody>
      </table>
      <Tracks tracks={tracks} />
    </>
  )
}

export default Artist
